import React, { FC } from 'react';
import styles from './styles.module.css';
import { Checkbox } from '@clearcover/atlas';
import { Statements } from 'QuoteApp/screens/Underwriting/Statements';

type UnderwritingEndorsementConsentProps = {
  markdown: string;
  accessConsentChecked: boolean;
  setAccessConsentChecked: (checked: boolean) => void;
};

export const UnderwritingEndorsementConsent: FC<
  UnderwritingEndorsementConsentProps
> = ({ markdown, accessConsentChecked, setAccessConsentChecked }) => {
  return (
    <>
      <h3>
        Before continuing, you must confirm the following information is true
      </h3>
      <Statements markdown={markdown} />
      <div className={styles.checkboxContainer}>
        <Checkbox
          data-testid="underwriting-consent"
          name="consent"
          label="I confirm this information has been verified with the applicant, and that they agree to all of the statements above."
          value={accessConsentChecked}
          className={styles.checkboxAgreement}
          // disabled={false}
          onChange={(checked) => {
            setAccessConsentChecked(checked);
          }}
        />
      </div>
    </>
  );
};
